import { useMutation, useQueryClient } from "@tanstack/react-query"
import { getSeamHttpClient } from "./use-seam-client"
import { DevicesSimulateConnectParameters } from "@seamapi/http"

export const useConnectDevice = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async ({
      workspace_id,
      ...params
    }: DevicesSimulateConnectParameters & { workspace_id: string }) => {
      const client = getSeamHttpClient(workspace_id)
      const result = await client.devices.simulate.connect(params)
      return result
    },
    onSuccess: (_, params) => {
      qc.invalidateQueries({ queryKey: ["devices", params.workspace_id] })
    },
  })
}
